export default "__VITE_ASSET__j7FtL83E__"